<template>
    <div class="dropdown" ref="nodeDropdown">
        <button
            class="btn btn-gray badge badge-gray"
            data-toggle="dropdown"
            data-offset="0,12"
            data-v-tour="navigation"
        >
            <span class="align-middle">{{ currentNode.number }} - {{ currentNodeTitle }}</span>
            <span class="icon icon-glyphicons-basic-chevron-down align-middle ml-1"></span>
        </button>
        <div class="dropdown-menu shadow-sm node-dropdown">
            <span class="dropdown-header h6 px-3">Jump to screen...</span>
            <a
                v-for="node in nodeList"
                :key="node.id"
                class="dropdown-item node-option px-3"
                :class="{ active: node.id == currentNode.id }"
                @click="selectNode(node)"
            >
                <span class="font-weight-500 node-option-label">{{ node.number }}. {{ node.title }}</span>
            </a>
        </div>
    </div>
</template>

<script>
import http from "@/axios.js"
import Utilities from "@/assets/js/utilities.js";

export default {
    name: "SessionNodeDropdown",
    props: {
        currentNode: {
            type: Object,
            required: true,
        },
    },
    data() {
        return {
            nodeList: [],
        }
    },
    computed: {
        sessionID() {
            return this.$route.params.sessionID
        },
        currentNodeTitle() {
            return Utilities.trimString(this.currentNode.title, 36)
        },
    },
    methods: {
        fetchNodes() {
            let vm = this
            http.get(`/api/sessions/${this.sessionID}/node-list/`).then(function (response) {
                vm.nodeList = response.data
            })
        },
        selectNode(node) {
            this.$emit("select", node)
        },
    },
    mounted() {
        $(this.$refs.nodeDropdown).on("shown.bs.dropdown", function () {
            let nodeElement = document.getElementsByClassName("node-option active").item(0)
            let scrollOptions = {
                block: "center",
                inline: "center",
                behavior: "smooth",
            }
            nodeElement.scrollIntoView(scrollOptions)
        })
        this.fetchNodes()
    },
}
</script>

<style lang="scss">
.node-option {
    padding-top: 3px;
    padding-bottom: 3px;
    overflow: hidden;
    text-overflow: ellipsis;
}

.node-option-label {
    font-size: 0.875rem;
}

.node-dropdown {
    width: 230px;
    max-height: 510px;
    overflow-y: scroll;
}
</style>